/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */
import { useMutation, useQuery } from 'react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { customInstance } from '../../../../mutator/instance';
import type {
  BondsmithPagePaymentInitiationResponse,
  ConfirmPaymentFailureRequest,
  ListPaymentInitiationsParams,
  PaymentInitiationResponse,
} from '../../models';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

export const listPaymentInitiations = (
  params?: ListPaymentInitiationsParams,
  signal?: AbortSignal
) => {
  return customInstance<BondsmithPagePaymentInitiationResponse>({
    url: `/operations/own/payment/initiation/status`,
    method: 'GET',
    params,
    signal,
  });
};

export const getListPaymentInitiationsQueryKey = (
  params?: ListPaymentInitiationsParams
) => {
  return [
    `/operations/own/payment/initiation/status`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListPaymentInitiationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listPaymentInitiations>>,
  TError = unknown
>(
  params?: ListPaymentInitiationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPaymentInitiations>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPaymentInitiationsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPaymentInitiations>>
  > = ({ signal }) => listPaymentInitiations(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPaymentInitiations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPaymentInitiationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPaymentInitiations>>
>;
export type ListPaymentInitiationsQueryError = unknown;

export const useListPaymentInitiations = <
  TData = Awaited<ReturnType<typeof listPaymentInitiations>>,
  TError = unknown
>(
  params?: ListPaymentInitiationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPaymentInitiations>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListPaymentInitiationsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const confirmPaymentInitiationFailure = (
  paymentInitiationUid: string,
  confirmPaymentFailureRequest: ConfirmPaymentFailureRequest
) => {
  return customInstance<void>({
    url: `/operations/own/payment/initiation/${paymentInitiationUid}/confirm-failure`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: confirmPaymentFailureRequest,
  });
};

export const getConfirmPaymentInitiationFailureMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmPaymentInitiationFailure>>,
    TError,
    { paymentInitiationUid: string; data: ConfirmPaymentFailureRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmPaymentInitiationFailure>>,
  TError,
  { paymentInitiationUid: string; data: ConfirmPaymentFailureRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmPaymentInitiationFailure>>,
    { paymentInitiationUid: string; data: ConfirmPaymentFailureRequest }
  > = (props) => {
    const { paymentInitiationUid, data } = props ?? {};

    return confirmPaymentInitiationFailure(paymentInitiationUid, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConfirmPaymentInitiationFailureMutationResult = NonNullable<
  Awaited<ReturnType<typeof confirmPaymentInitiationFailure>>
>;
export type ConfirmPaymentInitiationFailureMutationBody =
  ConfirmPaymentFailureRequest;
export type ConfirmPaymentInitiationFailureMutationError = unknown;

export const useConfirmPaymentInitiationFailure = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmPaymentInitiationFailure>>,
    TError,
    { paymentInitiationUid: string; data: ConfirmPaymentFailureRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof confirmPaymentInitiationFailure>>,
  TError,
  { paymentInitiationUid: string; data: ConfirmPaymentFailureRequest },
  TContext
> => {
  const mutationOptions =
    getConfirmPaymentInitiationFailureMutationOptions(options);

  return useMutation(mutationOptions);
};
export const retryFailedPayment = (paymentInitiationUid: string) => {
  return customInstance<void>({
    url: `/operations/own/payment/initiation/${paymentInitiationUid}/retry`,
    method: 'POST',
  });
};

export const getRetryFailedPaymentMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryFailedPayment>>,
    TError,
    { paymentInitiationUid: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof retryFailedPayment>>,
  TError,
  { paymentInitiationUid: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof retryFailedPayment>>,
    { paymentInitiationUid: string }
  > = (props) => {
    const { paymentInitiationUid } = props ?? {};

    return retryFailedPayment(paymentInitiationUid);
  };

  return { mutationFn, ...mutationOptions };
};

export type RetryFailedPaymentMutationResult = NonNullable<
  Awaited<ReturnType<typeof retryFailedPayment>>
>;

export type RetryFailedPaymentMutationError = unknown;

export const useRetryFailedPayment = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryFailedPayment>>,
    TError,
    { paymentInitiationUid: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof retryFailedPayment>>,
  TError,
  { paymentInitiationUid: string },
  TContext
> => {
  const mutationOptions = getRetryFailedPaymentMutationOptions(options);

  return useMutation(mutationOptions);
};
export const enquireInProgressPaymentStatus = (
  paymentInitiationUid: string
) => {
  return customInstance<PaymentInitiationResponse>({
    url: `/operations/own/payment/initiation/${paymentInitiationUid}/status/poll`,
    method: 'POST',
  });
};

export const getEnquireInProgressPaymentStatusMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof enquireInProgressPaymentStatus>>,
    TError,
    { paymentInitiationUid: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof enquireInProgressPaymentStatus>>,
  TError,
  { paymentInitiationUid: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof enquireInProgressPaymentStatus>>,
    { paymentInitiationUid: string }
  > = (props) => {
    const { paymentInitiationUid } = props ?? {};

    return enquireInProgressPaymentStatus(paymentInitiationUid);
  };

  return { mutationFn, ...mutationOptions };
};

export type EnquireInProgressPaymentStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof enquireInProgressPaymentStatus>>
>;

export type EnquireInProgressPaymentStatusMutationError = unknown;

export const useEnquireInProgressPaymentStatus = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof enquireInProgressPaymentStatus>>,
    TError,
    { paymentInitiationUid: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof enquireInProgressPaymentStatus>>,
  TError,
  { paymentInitiationUid: string },
  TContext
> => {
  const mutationOptions =
    getEnquireInProgressPaymentStatusMutationOptions(options);

  return useMutation(mutationOptions);
};
export const updatePaymentInitiationStatus = (
  paymentInitiationUid: string,
  statusCode: string
) => {
  return customInstance<void>({
    url: `/operations/own/payment/initiation/${paymentInitiationUid}/status/${statusCode}`,
    method: 'PATCH',
  });
};

export const getUpdatePaymentInitiationStatusMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePaymentInitiationStatus>>,
    TError,
    { paymentInitiationUid: string; statusCode: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePaymentInitiationStatus>>,
  TError,
  { paymentInitiationUid: string; statusCode: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePaymentInitiationStatus>>,
    { paymentInitiationUid: string; statusCode: string }
  > = (props) => {
    const { paymentInitiationUid, statusCode } = props ?? {};

    return updatePaymentInitiationStatus(paymentInitiationUid, statusCode);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePaymentInitiationStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePaymentInitiationStatus>>
>;

export type UpdatePaymentInitiationStatusMutationError = unknown;

export const useUpdatePaymentInitiationStatus = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePaymentInitiationStatus>>,
    TError,
    { paymentInitiationUid: string; statusCode: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updatePaymentInitiationStatus>>,
  TError,
  { paymentInitiationUid: string; statusCode: string },
  TContext
> => {
  const mutationOptions =
    getUpdatePaymentInitiationStatusMutationOptions(options);

  return useMutation(mutationOptions);
};
